import {
  Appointment01Icon,
  Briefcase02Icon,
  CalendarCheckOut01Icon,
  Cancel01Icon,
  FileSyncIcon,
  InformationCircleIcon,
  PrisonerIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import moment from "moment";
import { IconButton, IconButtonSize } from "shared/components";
import { IncomeType } from "shared/types";

export const IntroView = ({
  applicantFullName,
  applicantRole,
  incomeSource,
  incomeName,
  incomeStartDate,
  incomeEndDate,
  onClose
}: {
  applicantFullName: string;
  applicantRole: string;
  incomeSource: IncomeType;
  // job title, company
  incomeName: string;
  incomeStartDate: string;
  incomeEndDate: string;
  onClose?: () => void;
}) => {
  return (
    <div className="p-6 relative">
      <IconButton
        HugeIcon={Cancel01Icon}
        size={IconButtonSize.SM}
        borderLess
        className="absolute top-4 right-4"
        onClick={onClose}
      />

      <div className="bg-primary-20 h-20 w-20 rounded-full flex items-center justify-center mx-auto mb-6">
        <HugeiconsIcon
          icon={FileSyncIcon}
          size={32}
          className="text-primary-500"
        />
      </div>

      <h1 className="text-xl text-content-1000 font-bold mb-2 text-center">
        Re-verify income source with documents
      </h1>
      <p className="pb-6 border-b border-alpha-40 text-center text-sm font-medium text-content-300">
        You can re-verify the income source by uploading an income documents
        here
      </p>

      <div className="mt-11 pb-11 mb-6 border-b border-alpha-40 space-y-2">
        <div className="flex items-center gap-2 text-sm font-medium text-content-400">
          <HugeiconsIcon icon={PrisonerIcon} size={20} className="shrink-0" />
          <p>Person</p>
          <p className="ml-auto">{`${applicantFullName}, ${applicantRole}`}</p>
        </div>
        <div className="flex items-center gap-2 text-sm font-medium text-content-400">
          <HugeiconsIcon
            icon={Briefcase02Icon}
            size={20}
            className="shrink-0"
          />
          <p>Income source</p>
          <p className="ml-auto">{`${incomeSource}, ${incomeName}`}</p>
        </div>

        <div className="flex items-center gap-2 text-sm font-medium text-content-400">
          <HugeiconsIcon
            icon={CalendarCheckOut01Icon}
            size={20}
            className="shrink-0"
          />
          <p>Start date</p>
          <p className="ml-auto">{moment(incomeStartDate).format("ll")}</p>
        </div>

        <div className="flex items-center gap-2 text-sm font-medium text-content-400">
          <HugeiconsIcon
            icon={Appointment01Icon}
            size={20}
            className="shrink-0"
          />
          <p>End date</p>
          <p className="ml-auto">
            {moment(incomeEndDate).isValid()
              ? moment(incomeEndDate).format("ll")
              : "Present"}
          </p>
        </div>
      </div>

      <div className="bg-warning-50 text-warning-700 px-6 py-4 rounded-lg border-alpha-100 flex gap-4 items-center">
        <HugeiconsIcon
          icon={InformationCircleIcon}
          size={20}
          className="shrink-0"
        />

        <p className="text-sm font-medium">
          Re-verifying this income source will replace the original verification
          and you will be charged an additional fee
        </p>
      </div>
    </div>
  );
};
